import React, { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

import Home from '../Site/Home';
// The old home page's stylesheets are global: other screens' headers and
// footers (.footer-top, .login-ft-btn, .create-event-col-*) and the legacy
// .search rules still rely on them, so they stay bundled.
import './Homepage.css';
import './Header.css';
import './Footer.css';

const Homepage = () => {
  const { state } = useLocation();
  const autherizer = localStorage.getItem('unauthorized');

  useEffect(() => {
    let sessionalert = state?.from;
    if (sessionalert && !autherizer) {
      localStorage.setItem('unauthorized', true);
      if (!localStorage.getItem('toastShown') && sessionalert !== '404PAGE') {
        toast.error(sessionalert, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          onClose: () => {
            localStorage.setItem('toastShown', 'true');
          },
        });
      }
    }
    if (sessionalert === '404PAGE') {
      toast.error('Please Log In', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        onClose: () => {
          localStorage.setItem('toastShown', 'true');
        },
      });
    }
  }, []);

  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Home />
      <ToastContainer />
    </>
  );
};

export default Homepage;
